import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="section-p1">
        <div className="col">
          <img className="logo2" id="logo" src="/img/logo.png" alt="Logo" />
          <h4>Contact</h4>
          <p><strong>Address:</strong> Sonadanga, Khulna, Bangladesh</p>
          <p><strong>Email:</strong> goldvines12@gmail.com</p>
          <p><strong>Phone:</strong> +880 1533 756806</p>
          <div className="follow">
            <h4>Follow Us</h4>
            <div className="icon">
              <i className="fab fa-facebook-f"></i>
              <i className="fab fa-instagram"></i>
              <i className="fab fa-youtube"></i>
            </div>
          </div>
        </div>

        <div className="col">
          <h4>About</h4>
          <Link to="/about">About Us</Link>
          <a href="#">Delivery Information</a>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
          <a href="#">Contact Us</a>
        </div>

        <div className="col">
          <h4>My Account</h4>
          <Link to="/login">Sign In</Link>
          <Link to="/cart">View Cart</Link>
          <a href="#">My Wishlist</a>
          <Link to="/orders">My Order</Link>
          <a href="#">Help</a>
        </div>

        <div className="col install">
          <h4>Install App</h4>
          <p>From App Store or Google Play</p>
          <div className="row">
            <img src="/img/pay/app.jpg" alt="App Store" />
            <img src="/img/pay/play.jpg" alt="Google Play" />
          </div>
          <p>Secured Payment Gateways</p>
          <img src="/img/pay/pay.png" alt="Payment Methods" />
        </div>

        <div className="colyright">© 2026, GoldVines.com.bd</div>
      </footer>
    </>
  );
};

export default Footer;